// Module
var code = `<div class="js-tercera-checkbox-button-container {{#.hasError}}error{{/}}"
     style="{{>visibility}}"
     as-tooltip="tooltip"
     {{>visualparameters}}
    {{#.checked}}checked{{/}}>

    <div on-click="@this.private_CheckBoxClick(this)"
         class="js-tercera-checkbox-button-text"
         on-mousedown="@this.onMouseDown(event)">

        {{.text}}
    </div>
</div>`;
// Exports
export default code;